import { render, staticRenderFns } from "./SubscriptionPlan.vue?vue&type=template&id=09d6a4fb&scoped=true&"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6a4fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
